import React from "react";
import Lottie from "react-lottie";
import animationDataLoading from "../animations/Loader.json"; // Replace with your creative animation

const LoadingScreen = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationDataLoading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-pink-50 ">
      <Lottie options={defaultOptions} height={300} width={300} />
    </div>
  );
};

export default LoadingScreen;
